import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { User } from '../models/user';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor( private http: HttpClient ) { }

  async getUsers(rol?:string) : Promise<User[]> {
    return this.http.get<User[]>('/api/user' + (rol ? "?rol=" + rol : "")).toPromise();
  }

  async postUser(user: User) : Promise<User> {
    return this.http.post<User>('/api/user', user).toPromise();
  }

  async getUser(id: Number) : Promise<User> {
    return this.http.get<User>('/api/user/' + id).toPromise();
  }
  
  async putUser(user: User) : Promise<User> {
    return this.http.post<User>('/api/user/' + user.id + '/edit', user).toPromise();
  }
  
  async deleteUser(user: User) : Promise<void> {
    return this.http.get<void>('/api/user/' + user.id + '/delete').toPromise();
  }

  async changeUserPasswords(user: User): Promise<User[]>{
    return this.http.post<User[]>('/api/user/' + user.id + '/password', user).toPromise();
  }
}
